import axios from 'axios';

const normalizeFiltersById = (map, current) => {
  const { orderFilterSetId } = current;
  return {
    ...map,
    [orderFilterSetId]: current,
  };
};

const getData = ({ data }) => (Array.isArray(data) ? data.reduce(normalizeFiltersById, {}) : {});

export const getFilterSets = () => axios.get('/orderfilterset').then(getData);
export const postFilterSet = (json) => axios.post('/orderfilterset', json).then((res) => res.data);
export const updateFilterSet = (json) => axios.put('/orderfilterset', json).then((res) => res.data);
export const deleteFilterSet = async (orderFilterSetId) => {
  const response = await axios.delete(`/orderfilterset/${orderFilterSetId}`);
  return response?.data ?? [];
};
